export default __webpack_public_path__ + "static/media/Brewfest.87da07c9.mp4";